const collection_001 = {
  id: 'exo_ann',
  name: 'eXo - Ann',
};

const collection_002 = {
  id: 'exo_gian',
  name: 'eXo - Gian',
};

const collection_003 = {
  id: 'exo_jr',
  name: 'eXo - JR',
};

const collection_004 = {
  id: 'exo_gusa',
  name: 'eXo - Gusa',
};

const collection_005 = {
  id: 'exo_dave',
  name: 'eXo - Dave',
};

const collection_006 = {
  id: 'exo_brandon',
  name: 'eXo - Brandon',
};

const collection_007 = {
  id: 'exo_juan',
  name: 'eXo - Juan',
};

export default [
  collection_001,
  collection_002,
  collection_003,
  collection_004,
  collection_005,
  collection_006,
  collection_007,
];
